import { render, staticRenderFns } from "./ManageSub.vue?vue&type=template&id=66de4ee3&scoped=true"
import script from "./ManageSub.vue?vue&type=script&lang=js"
export * from "./ManageSub.vue?vue&type=script&lang=js"
import style0 from "./ManageSub.vue?vue&type=style&index=0&id=66de4ee3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66de4ee3",
  null
  
)

export default component.exports